import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppConfig } from '../../AppConfig';
import { AppTheme, AppStyles } from '../../styles/AppTheme';
import { CommonStyles } from '../../styles/Styles';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';
import { Icon } from '@material-ui/core';
import { ValidationHelper } from '../../common/helpers/ValidationHelper';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import { ImageComponent } from '../../components/quizzing/ImageComponent';

export class SelectComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value
    }
    this.ids = {} //TODO
    //this.ids = []
  }

  change = e => {
    this.setState({ value: e.target.value }); //TODO: uncommented this line, why was this commented by azyd5?
    this.props.handleState(e.target.name, e.target.value)
  }

  handleSelect = e => {
    if (this.state[e.target.name] === e.target.value) {
      this.setState({ [e.target.name]: undefined });
      delete this.ids[e.target.name]
    } else {
      this.setState({ [e.target.name]: e.target.value });
      this.ids[e.target.name] = e.target.value
    }

    let ids = []
    for (const key in this.ids) {
      const resp = {}
      resp[key] = { value: this.ids[key] }
      ids.push(resp)
    }

    if (ids.length === 0) {
      ids = null
    }

    this.props.handleState(this.props.data.id, ids)
  }

  /*menuItem = (value) => {
    const arr = []
    for (let i = 0; i <= value; i++) {
      arr.push(
        <MenuItem
          value={i} key={i}
          className={css(Styles.menuItemContainer)}>
          <p className={css(Styles.margin)}>{i}</p>
        </MenuItem>
      )
    }
    return arr
  }*/

  menuItem = (value) => {
    if(!value) return
    const options = value.split(',')
    const arr = []
    for (const option of options) {
      arr.push(
        <MenuItem
          value={option}
          key={option}
          className={css(Styles.menuItemContainer)}>
          <p className={css(Styles.margin)}>{option}</p>
        </MenuItem>
      )
    }
    return arr
  }

  render() {
    const thisObj = this //TODO
    return (
      <div className={css(CommonStyles.outerContainer)}>
        <div>
          {this.props.mainTitle &&
            <div className={css(CommonStyles.questionMainTitleContainer)}>
              <p className={css(CommonStyles.questionMainTitle)}>{this.props.mainTitle}</p>
              {this.props.showInformationPopup &&
                <div className={css(CommonStyles.questionDetailContainer)} onClick={() => this.props.showInformationPopup(this.props.data)}>
                  <p className={css(CommonStyles.questionDetailContent)}>i</p>
                </div>
              }
            </div>
          }
          {this.props.data.subTitle &&
            <p className={css(CommonStyles.questionSubTitle)}>{this.props.data.subTitle}</p>
          }
        </div>
        {this.props.data.image &&
          <div className={css(CommonStyles.outerImageContainer)}>
            <ImageComponent data={this.props.data} />
          </div>
        }
        <div className={css(this.props.survey ? Styles.innerContainer : CommonStyles.innerContainer)}>
          {this.props.survey &&
            <Grid container spacing={3} className={css(Styles.outerMainContainer)}>
              {Object.keys(this.props.data.options).sort(function (a, b) { return (Number(thisObj.props.data.options[a].order) - Number(thisObj.props.data.options[b].order)) })
                .map(item => {
                  return (
                    <Grid item xs={6} className={css(Styles.outerContainer)} key={item}>
                      <div className={css(Styles.titleContainer)}>
                        <p className={css(Styles.selectTitleContainer)}>{this.props.data.options[item].title}</p>
                      </div>
                      <FormControl className={css(Styles.selectOuterContainer)}>
                        <Select
                          disabled={this.props.disabled}
                          displayEmpty
                          name={this.props.data.options[item].id}
                          className={this.props.disabled ? css(Styles.selectInnerContainerDisabled) : css(Styles.selectInnerContainer)}
                          value={String(this.state[this.props.data.options[item].id])}
                          onChange={this.handleSelect}
                          IconComponent={props => (
                            <Icon {...props} >
                            expand_more
                            </Icon>
                          )}
                          MenuProps={{
                            anchorOrigin: {
                              vertical: 'bottom',
                              horizontal: 'left'
                            },
                            transformOrigin: {
                              vertical: 'top',
                              horizontal: 'left'
                            },
                            getContentAnchorEl: null,
                            classes: {
                              paper: css(Styles.menuItemContainerRoot),
                            }
                          }}
                          input={
                            <Input
                              disableUnderline={true}
                            />
                          }
                          classes={{
                            selectMenu: this.props.disabled ? css(Styles.selectDisabled) : css(Styles.select),
                            icon: css(Styles.selectIcon),
                          }}
                        >
                          <MenuItem value={undefined} key={undefined} disabled className={css(Styles.inputLabel)} >
                          Select one
                          </MenuItem>
                          {this.menuItem(this.props.data.options[item].acceptOptions)}
                        </Select>
                        <FormHelperText
                          className={css(CommonStyles.errorMsgStyle)}>
                          {!this.props.enableValidation ? '' : ValidationHelper.validateFields(this.props.data, this.state.value)}
                        </FormHelperText>
                      </FormControl>

                    </Grid>
                  )
                })}
            </Grid>
          }

          {!this.props.survey &&
            <FormControl className={css(Styles.selectOuterContainer)}>
              <Select
                disabled={this.props.disabled}
                displayEmpty
                name={this.props.data.id}
                className={this.props.disabled ? css(Styles.selectInnerContainerDisabled) : css(Styles.selectInnerContainer)}
                value={this.state.value}
                onChange={this.change}
                IconComponent={props => (
                  <Icon {...props} >
                    expand_more
                  </Icon>
                )}
                MenuProps={{
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                  },
                  transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left'
                  },
                  getContentAnchorEl: null,
                  classes: {
                    paper: css(Styles.menuItemContainerRoot),
                  }
                }}
                input={
                  <Input
                    disableUnderline={true}
                  />
                }
                label={css(CommonStyles.formLabel)}
                classes={{
                  selectMenu: this.props.disabled ? css(Styles.selectDisabled) : css(Styles.select),
                  icon: css(Styles.selectIcon),
                }}
              >
                <MenuItem value='' disabled className={css(Styles.inputLabel)} >
                  {this.props.data.title}
                </MenuItem>
                {this.props.data.options.map(item => {
                  return (
                    <MenuItem
                      value={item.id} key={item.id}
                      className={css(Styles.menuItemContainer)}>
                      <p className={css(Styles.margin)}>{item.title}</p>
                    </MenuItem>
                  )
                })}
              </Select>
              <FormHelperText
                className={css(CommonStyles.errorMsgStyle)}>
                {!this.props.enableValidation ? '' : ValidationHelper.validateFields(this.props.data, this.state.value)}
              </FormHelperText>
            </FormControl>
          }

        </div>
      </div >
    );
  }
}

const Styles = StyleSheet.create({
  selectOuterContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
  titleContainer: {
    minHeight: '60%', //TODO
    display: 'flex',
    alignItems: 'flex-end',
    marginBottom: 5,
    '@media (max-width: 767px)': {
      minHeight: 'unset',
    }
  },
  selectTitleContainer: {
    margin: 0,
    fontSize: AppTheme.subTitleSize,
    marginLeft: 10,
    color: AppTheme.primaryColor,
    '@media (max-width: 767px)': {
      fontSize: AppTheme.subTitleSizeBelow767,
    }
  },
  select: {
    backgroundColor: AppTheme.secondaryBg,
    color: '#656A78',
    fontSize: AppTheme.subTitleSize,
    padding: 10,
    paddingLeft: 15,
    height: 25,
    display: 'flex',
    alignItems: 'center',
    borderRadius: 18,
    '@media (max-width: 767px)': {
      height: 20,
      fontSize: AppTheme.subTitleSizeBelow767,
    },
  },
  selectDisabled: {
    backgroundColor: 'lightgrey',
    color: '#656A78',
    fontSize: AppTheme.subTitleSize,
    padding: 10,
    paddingLeft: 15,
    height: 25,
    display: 'flex',
    alignItems: 'center',
    borderRadius: 18,
    '@media (max-width: 767px)': {
      height: 20,
      fontSize: AppTheme.subTitleSizeBelow767,
    },
  },
  selectIcon: {
    color: AppTheme.tertiaryColor,
    fontSize: 45,
    marginTop: -10,
    '@media (max-width: 767px)': {
      fontSize: 35,
      marginTop: -5,
    },
  },
  selectInnerContainer: {
    color: '#656A78',
    border: '3px solid' + AppTheme.borderColor,
    borderRadius: 18,
    backgroundColor: AppTheme.secondaryBg,
    width: '100%',
  },
  selectInnerContainerDisabled: {
    color: '#656A78',
    border: '3px solid' + AppTheme.borderColor,
    borderRadius: 18,
    backgroundColor: 'lightgrey',
    width: '100%'
  },
  menuItemContainerRoot: {
    backgroundColor: AppTheme.secondaryBg,
  },
  inputLabel: {
    color: '#656A78',
  },
  menuItemContainer: {
    color: '#656A78',
    padding: 0,
    paddingLeft: 10,
    margin: 5,
    borderRadius: 18,
    ':hover': {
      backgroundColor: AppTheme.hoverColor,
      color: '#656A78',
    }
  },

  innerContainer: {
    marginTop: 20,
    marginLeft: 20,
    marginBottom: 20,
    '@media (max-width: 767px)': {
      marginLeft: 10,
      marginBottom: 15,
    }
  },
  outerMainContainer: {
    width: '100%',
    '@media (max-width: 767px)': {
      margin: 0,
    }
  },
  outerContainer: {
    '@media (max-width: 767px)': {
      padding: 5,
    }
  },
})


// WEBPACK FOOTER //
// ./src/components/quizzing/SelectComponent.js